import { useMutation } from "@tanstack/react-query";
import api from "../api/api";
import type { CreatePendingInstallmentInputDto } from "../types/codegen";

export const useCreatePendingInstallment = () => {
  return useMutation({
    mutationFn: async (input: CreatePendingInstallmentInputDto) => {
      await api.post("/transactions/aqsati/create-pending-installment", input);
    },
  });
};
